import React, { useState, useEffect } from 'react';
import './templates.css';
import MinimalTemplate from './templates/MinimalTemplate';
import ClassicTemplate from './templates/ClassicTemplate';
import CvfolioTemplate from './templates/CvfolioTemplate';
import ModernTemplate from './templates/ModernTemplate';

const SubdomainSite = ({ subdomain }) => {
    const [siteData, setSiteData] = useState({
        hero: { name: '', title: '', description: '', github_url: '', linkedin_url: '' },
        experiences: [],
        education: [],
        competencies: [],
        tools: [],
        languages: []
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [templateKey, setTemplateKey] = useState('default');

    const loadSiteData = React.useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            // Load all site data
            const [metaRes, heroRes, experiencesRes, educationRes, competenciesRes, toolsRes, languagesRes] = await Promise.all([
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/meta`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/hero`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/experiences`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/education`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/competencies`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/tools`),
                fetch(`https://personal-site-saas-api.l5819033.workers.dev/api/site/${subdomain}/languages`)
            ]);

            const meta = metaRes.ok ? await metaRes.json() : { template_key: 'default' };
            const hero = heroRes.ok ? await heroRes.json() : { name: '', title: '', description: '', github_url: '', linkedin_url: '', cv_url: '' };
            const experiences = experiencesRes.ok ? await experiencesRes.json() : [];
            const education = educationRes.ok ? await educationRes.json() : [];
            const competencies = competenciesRes.ok ? await competenciesRes.json() : [];
            const tools = toolsRes.ok ? await toolsRes.json() : [];
            const languages = languagesRes.ok ? await languagesRes.json() : [];

            setTemplateKey(meta.template_key || 'default');
            setSiteData({
                hero,
                experiences,
                education,
                competencies,
                tools,
                languages
            });

        } catch (error) {
            console.error('Error loading site data:', error);
            setError('Site yüklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    }, [subdomain]);

    useEffect(() => {
        loadSiteData();
    }, [loadSiteData]);

    // Update document title with user's name (fallback BioSite)
    useEffect(() => {
        const name = siteData?.hero?.name?.trim();
        if (name && name.length > 0) {
            document.title = name;
        } else {
            document.title = 'BioSite';
        }
    }, [siteData?.hero?.name]);

    if (loading) {
        return (
            <div className="subdomain-loading">
                <div className="loading-spinner"></div>
                <p>Site yükleniyor...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="subdomain-error">
                <h2>Site Bulunamadı</h2>
                <p>Bu site mevcut değil veya yayınlanmamış.</p>
                <a href="/" className="home-link">Ana Sayfaya Dön</a>
            </div>
        );
    }

    // Backward compatibility: accept legacy key 'eren-github' as 'classic'
    const isClassic = templateKey === 'classic' || templateKey === 'eren-github';
    return (
        <div>
            {isClassic ? (
                <ClassicTemplate subdomain={subdomain} />
            ) : templateKey === 'cvfolio' ? (
                <CvfolioTemplate subdomain={subdomain} />
            ) : templateKey === 'modern' ? (
                <ModernTemplate data={siteData} subdomain={subdomain} />
            ) : (
                <MinimalTemplate data={siteData} subdomain={subdomain} />
            )}
        </div>
    );
};

export default SubdomainSite;